export default "/_nuxt/82f2cc58fda0d869add89c13583552f3.svg";